export class AudioMixerEffect {

    constructor(mixAudio) {
        if (mixAudio.getType() !== "audio") {
            throw new Error('AudioMixerEffect only supports audio tracks; effect will not work!');
        }

        this._mixAudio = mixAudio;
            /**
         * track that is going to be mixed into the track that uses this effect.
         */
        this._mixAudio;

        /**
         * MediaStream resulted from mixing.
         */
        this._mixedMediaStream;

        /**
         * MediaStreamTrack obtained from mixed stream.
         */
        this._mixedMediaTrack;

        /**
         * Original MediaStream from the track that uses this effect.
         */
        this._originalStream;

        /**
         * MediaStreamTrack obtained from the original MediaStream.
         */
        this._originalTrack;

        /**
         *  AudioMixer.
         */
        this._audioMixer;
    }

    isEnabled(sourceLocalTrack) {
        // Both tracks need to be audio i.e. contain an audio MediaStreamTrack
        return sourceLocalTrack.isAudioTrack() && this._mixAudio.isAudioTrack();
    }

    /**
     * Effect interface called by source local mic track, At this point a WebAudio ChannelMergerNode is created
     * and and the two associated MediaStreams are connected to it; the resulting mixed MediaStream is returned.
     *
     * @param {MediaStream} audioStream - Audio stream which will be mixed with _mixAudio.
     * @returns {MediaStream} - MediaStream containing both audio tracks mixed together.
     */
    startEffect(audioStream) {
        this._originalStream = audioStream;
        this._originalTrack = audioStream.getTracks()[0];

        this._audioMixer = KinoJS.createAudioMixer();
        this._audioMixer.addMediaStream(this._mixAudio.getOriginalStream());
        this._audioMixer.addMediaStream(this._originalStream);

        this._mixedMediaStream = this._audioMixer.start();
        this._mixedMediaTrack = this._mixedMediaStream.getTracks()[0];

        return this._mixedMediaStream;
    }

    /**
     * Reset the AudioMixer stopping it in the process.
     *
     * @returns {void}
     */
    stopEffect() {
        this._audioMixer.reset();
    }

    /**
     * Change the muted state of the effect.
     *
     * @param {boolean} muted - Should effect be muted or not.
     * @returns {void}
     */
    setMuted(muted) {
        this._originalTrack.enabled = !muted;
    }

    /**
     * Check whether or not this effect is muted.
     *
     * @returns {boolean}
     */
    isMuted() {
        return !this._originalTrack.enabled;
    }
}
